<template lang="pug">
  .card-teaser(v-if="display === 'card'" :class="{ hover: mouseover }")
    router-link(
      v-if="route"
      :to="route"
      @mouseover.native="hover"
      @mouseleave.native="blur"
    )
      Picture(
        v-if="image"
        :show-spinner="false"
        :image="image"
        :lazy="true"
        :optimize="optimize"
        :ignore-container-padding="true"
        missing-icon="exclamation-triangle"
        object-fit="cover"
        :debug="true"
        :title="title"
      )
    p.topic.is-uppercase.has-text-weight-bold(v-if="topic")
      | {{ topic }}
    h3.is-size-5(v-if="title")
      | {{ title }}
    .date.has-text-weight-bold(v-if="date") {{ date }}
    .bait(v-if="text")
      div(v-line-clamp:24="3")
        p.content(v-html="striptags(text)")
    .link(v-if="route")
      router-link(:to="route") Weiterlesen ...
  .row-teaser(v-else :class="{ hover: mouseover }")
    .image
      router-link(
        :to="route"
        @mouseover.native="hover"
        @mouseleave.native="blur"
      )
        Picture(
          v-if="image"
          :show-spinner="false"
          :image="image"
          :lazy="true"
          :optimize="optimize"
          :ignore-container-padding="true"
          missing-icon="exclamation-triangle"
          object-fit="cover"
          :debug="true"
          :title="title"
        )
    .text
      .topic-wrap
        p.topic.is-uppercase.has-text-primary.has-text-weight-bold(v-if="topic || referencedCmsName")
          span.left(v-if="topic") {{ topic }}
          span.right(v-if="referencedCmsName") {{ referencedCmsName }}
        .date.has-text-weight-bold(v-if="date") {{ date }}

      h3.is-size-4(v-if="title")
        | {{ title }}
      .bait(v-if="text")
        div(v-line-clamp:24="topic ? 4 : 5")
          p.content(v-html="striptags(text)")
      .link(v-if="route")
        router-link(:to="route") Weiterlesen ...
</template>

<script>
import { get, trim } from '@/helpers';
import striptags from 'striptags';
import { fromUnixTime, format, parseISO } from 'date-fns';
import { mapGetters } from 'vuex';

export default {
  name: 'Teaser',
  data() {
    return {
      delay: 150,
      mouseover: false,
      // showImage: true
      loaded: false,
      loading: true,
      error: false
    };
  },
  props: {
    page: {
      type: Object,
      required: true
    },
    showTopic: {
      type: Boolean,
      default: false
    },
    origin: {
      type: [String, Number],
      required: true
    },
    display: {
      type: String,
      default: 'row'
    },
    showDate: {
      type: Boolean,
      default: false
    },
    optimize: {
      // if speed is selected, get only prerendered variants if possible
      type: String,
      default: 'traffic',
      validator: val => ['speed', 'traffic'].includes(val)
    }
  },
  computed: {
    image() {
      let image;

      if (this.page?.teaser?.contents?.length) {
        const content = this.page.teaser.contents.find(content => content.key === 'image');
        if (content && content.images.length) image = content.images[0];
      }

      return image;
    },
    route() {
      let name;

      let categoryKey = get(this.page, 'category.key');
      const key = this.page.key;

      // let categoryPath;
      switch (categoryKey) {
        case 'news':
          // categoryPath = `/news/${key}`;
          name = 'aktuelles';
          break;

        default:
          name = 'not-found';
          break;
      }

      let route = {
        name,
        params: { key },
        query: {
          origin: this.origin
        }
      };

      let src;
      const referencedPost = get(this.page, 'category.cms.id') !== this.cms.id;
      if (referencedPost) src = get(this.page, 'category.cms.id');
      else src = get(this.reference, 'menuItem.menu.cms.id');
      if (src) route.params.src = src;

      return route;
    },
    topic() {
      if (this.showTopic) return get(this.page, 'category.name');
      else return null;
    },

    date() {
      const createdAt = get(this.page, 'created_at');

      if (createdAt && this.showDate) {
        const date = parseISO(format(fromUnixTime(createdAt), 'yyyy-MM-dd'));
        const formdate = format(new Date(date), 'dd.MM.yyyy');

        return formdate;
      } else {
        return false;
      }
    },
    title() {
      return get(this.page, 'title');
    },
    referencedCmsName() {
      let name;
      const referencedCmsID = get(this.page, 'category.cms.id');
      if (referencedCmsID && referencedCmsID !== this.cms.id) {
        name = get(this.page, 'category.cms.name');
      }
      return name;
    },
    text() {
      let content;
      if (this.page?.teaser?.contents?.length) {
        content = this.page.teaser.contents.find(content => content.key === 'teaser');
      }
      return content?.text;
    },
    ...mapGetters({
      reference: 'reference',
      cms: 'CMS'
    })
  },
  methods: {
    hover() {
      this.$emit('focus', this.item);
      this.mouseover = true;
    },
    blur() {
      setTimeout(() => {
        this.$emit('blur', this.item);
        this.mouseover = false;
      }, this.delay);
    },
    striptags(html) {
      html = html.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br />');
      return striptags(html, ['a', 'i', 'u', 'b', 'em', 'strong', 'span', 'br']);
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.card-teaser, .row-teaser
  .topic-wrap
    display: flex
    .date
      margin-left: auto

  text-align: initial
  h3
    line-height: 1.3
    color: var(--color-primary)
    font-weight: 600
    margin-bottom: 10px
  .topic
    font-size: .85rem
    margin-bottom: 10px
  .date
    font-size: .85rem
  .bait
    margin-bottom: 10px
    div
      word-break: normal !important
      br + br
        display: none
  .picture-container
    @apply rounded
    position: relative
    width: 100%
    padding-bottom: 56.25% // 9 / 16
    display: block
    background: #D8D8D8
    transition: transform .3s cubic-bezier(0, 0.9, 0.31, 1.04)
    &::v-deep
      figure
        @apply rounded
        &:after
          @apply rounded
          content: ''
          position: absolute
          top: 0
          left: 0
          height: 100%
          width: 100%
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)
          // z-index: -1
          transform: translateZ(-50px)
          transition: .3s cubic-bezier(0, 0.9, 0.31, 1.04)
        img
          @apply rounded
      &.loading, &.error
        picture
          width: 100% !important
          height: 100% !important
  &.hover
    a .picture-container
      transform: scale(1.02)
      &::v-deep
        figure:after
          box-shadow: 0 10px 50px -10px rgba(0, 0, 0, 0.2), 0 40px 80px 0 rgba(0, 0, 0, 0.05)

.card-teaser
  .picture-container
    margin-bottom: 20px

@screen md
  .row-teaser
    display: flex
    flex-direction: row
    .image
      flex-basis: 320px
      flex-grow: 0
      flex-shrink: 0
      // figure
      //   margin-bottom: 0
    .topic
      display: flex
      flex-grow: 1
      justify-content: space-between
      margin-bottom: 0
      .right
        color: rgb(87, 87, 85)
    .date
      padding-left: 1rem
    .text
      margin-left: 20px
      flex-grow: 1
      display: flex
      flex-direction: column
      .bait
        flex-grow: 1
</style>
